import { sidebarWidth } from './../../components/sidebar/Sidebar'
export const cityStatusStyles = {
  content: {
    padding: '70px 20px 20px 20px',
    marginLeft: sidebarWidth,
    width: '100%' - sidebarWidth
  },
  btnConfig: {
    background: 'none'
  },
  btnLanguage: {
    background: 'none'
  },
  findField: {
    width: '98%',
    backgroundColor: '#efa817',
    margin: '10 px 0 0 0',
    border: 0,
    padding: '10px',
    color: '#fff'
  }
}
